import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import {Formik, Field, Form, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import HomeNav from "components/Navbars/HomeNav.js";
import queryString from 'query-string';
import {Modal} from "react-bootstrap";
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';

// reactstrap components
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Label,
  Input,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Button,
  UncontrolledCollapse
} from "reactstrap";

// core components
import HomePageHeader from "components/Headers/HomePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import { 
  donorFormSubmitAction, 
  updateDonorAction,
  selfserviceDonorAction, 
  fetchDonorByPhoneAction } from 'actions/donorActions';
//import PlacesAutoComplete from "components/GoogleMapsAutoComplete/PlacesAutoComplete.js";
const moment = require('moment');

class LiquidLoveDonorPage extends Component {
  constructor(props) {
    super(props);
    this.buttonRef = React.createRef();
    this.state = {      
      firstFocus: false,
      lastFocus: false,
      fullName: '',
      dateOfBirth: '',
      gender: '',
      bloodGroup: 'O+',
      email: '',
      phone: '',
      alternatePhone: '',
      lastDonatedOn: '',
      pincode: '',
      accessMode: '',
      donorRowIdx: '',
      availableAfter: '',
      officeAddres: '',
      officePincode: '',
      officePhone: '',
      occupation: '',
      frequency: '4',
      notes: '',
      isActive: 'Y',
      show: false,
      isSuccess: false,
      modalOKEnabled: false,
      donorPhone: '',
      agreement: false
    }
    this.setShow = this.setShow.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleChange(event) {
    const value = event.target.value;
    this.setState({
      ...this.state,
      [event.target.name]: value
    });
  }

  componentDidMount() {
    document.title = 'Liquid Love Donor';
    document.body.classList.add("landing-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    
    if(this.state.accessMode !== 'admin')
      loadCaptchaEnginge(6);
  }

  componentWillMount() {
    //check if the mode is admin
    let params = queryString.parse(this.props.location.search);
    this.state.accessMode = params.accessMode;
    this.state.donorRowIdx = params.rowIndex;
    this.state.donorPhone = params.donorPhone;
    this.state.show = false;
    this.state.isSuccess = false;
    this.state.modalOKEnabled = false;

    if (this.state.accessMode === 'admin' && !this.props.response.login.isSignedIn) {
      //user not logged in..redirect to login page
      if(this.state.donorRowIdx)
        this.props.response.login.redirectAfterSignInTo = '/liquidlove/donor?accessMode=admin&rowIndex=' + this.state.donorRowIdx;
      else
        this.props.response.login.redirectAfterSignInTo = '/liquidlove/donor?accessMode=admin&donorPhone=' + this.state.donorPhone;
    }
    
    //If donor phone is present in request fetch donor based on phone number
    if (this.state.accessMode === 'admin' && this.state.donorPhone) {
      const payload = { 
        pageNum: 0,
        size: 1,
        phone: this.state.donorPhone,
        token: this.props.response.login.userToken
      }
      this.props.dispatch(fetchDonorByPhoneAction(payload));
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("landing-page");
    document.body.classList.remove("sidebar-collapse");
    /*if(this.props.response.places.address !== 'undefined')
      this.props.response.places.address = '';*/

      if(this.props.response.address !== 'undefined')
        this.props.response.address = '';

    if(this.props.response.donor.response !== 'undefined')
      delete this.props.response.donor.response;
    
    if(this.props.response.donor.allDonors !== 'undefined')
      delete this.props.response.donor.allDonors;

      this.props.response.donor.noServiceResponse = false;
      this.props.response.donor.redirectUrl = '';
  }

  backToDonors() {
    this.props.navigate('/liquidlove/donors');  
  }

  backToRequests() {
    this.props.navigate('/liquidlove/requests');    
  }

  setShow(bool) {
    this.setState({ show: bool });
  }
  handleClose = () => { 
    this.setShow(false) 
    if(this.state.isSuccess && this.state.accessMode === 'admin'){      
      
      if(this.props.response.donor.response !== 'undefined')
      delete this.props.response.donor.response;
    
      if(this.props.response.donor.allDonors !== 'undefined')
        delete this.props.response.donor.allDonors;

      this.props.response.donor.noServiceResponse = false;      

      if(this.props.response.donor.redirectUrl != ''){ //admin navigated from patientdetails page and must be redirected back
        let redirectUrl = this.props.response.donor.redirectUrl;
        this.props.response.donor.redirectUrl = '';
        this.props.navigate(redirectUrl);
      }
      else
        this.props.navigate('/liquidlove/donors');
    }
    else if(this.state.isSuccess && this.state.accessMode === 'self-service'){
      this.props.response.donor.sendOTPDonor.donor = this.props.response.donor.response;
      this.props.navigate('/liquidlove/home');
    } 
    else if(this.state.isSuccess)
      this.props.navigate('/liquidlove/home');
  };
  
  handleShow = () => { this.setShow(true) };

  render() {       
  let message;
  message = 'Sairam! Processing your request'
  
  if (this.state.accessMode === 'self-service' && !this.props.response.donor.isDonorVerified) {
    return <Navigate to={'/liquidlove/verify/donor'} />
  }

  if (this.props.response.hasOwnProperty('donor') &&
  this.props.response.donor.hasOwnProperty('response')){
    this.state.modalOKEnabled = true; 
    if(this.props.response.donor.response !== undefined)      
      if(this.props.response.donor.response.hasOwnProperty('error'))
        if(this.props.response.donor.response.message.includes('donor_phone_key'))
          message = 'Sairam! Provided phone is already registered as donor.';
        else if(this.props.response.donor.response.status === 401 && this.state.accessMode === 'admin')
          message = 'Your session has expired. Please login again'
        else if(this.props.response.donor.response.status === 401 && this.state.accessMode === 'self-service')
          message = 'Invalid or expired OTP. Click Donor->Update profile menu to resend OTP'
        else
          message = this.props.response.donor.response.message;
      else if(this.props.response.donor.response.cause !== undefined &&
        this.props.response.donor.response.cause.cause !== undefined &&
        this.props.response.donor.response.cause.cause.message !== undefined &&
        this.props.response.donor.response.cause.cause.message.includes('ERROR: duplicate key value violates unique constraint'))
        message = 'Sairam! Provided phone is already registered as donor.';        
      else{
        this.state.isSuccess = true;
        if(this.state.accessMode === 'admin' || this.state.accessMode === 'self-service')
          message = 'Sairam! Donor details are updated.';
        else
          message = 'Sairam! Your are registered as a donor.';
      } 
    else if(this.props.response.donor.noServiceResponse)
      message = 'Sairam. Sorry! We are not able to save your details. Please try later.';
  }
  if (this.state.accessMode === 'admin' && !this.props.response.login.isSignedIn) {
    return <Navigate to={'/liquidlove/login'} />
  }      
  let donorData = '';
   
  if(this.state.accessMode === 'admin' && this.state.donorRowIdx)
    donorData = this.props.response.donor.allDonors.content[this.state.donorRowIdx]
  else if(this.state.accessMode === 'admin' && this.state.donorPhone){
    donorData = (this.props.response.donor.hasOwnProperty('allDonors') && 
    this.props.response.donor.allDonors.content) ? this.props.response.donor.allDonors.content[0] : ''
  }
  else if(this.state.accessMode === 'self-service')
    donorData = this.props.response.donor.sendOTPDonor.donor;
  
  return (        
    <Formik enableReinitialize={true}
          initialValues={{
              fullName: donorData !== '' ? donorData.fullname : '',
              dateOfBirth: donorData !== '' ? donorData.dateOfBirth : 'dd-mm-yyyy',
              gender: donorData !== '' ? donorData.gender : 'male',
              bloodGroup: donorData !== '' ? donorData.bloodGroup : 'O+',
              email: donorData !== '' ? donorData.email : '',
              phone: donorData !== '' ? donorData.phone : '',
              address: donorData !== '' ? donorData.address : '',
              pincode: donorData !== '' ? donorData.pincode : '',
              lastDonatedOn: donorData !== '' ? (donorData.lastDonatedOn ? donorData.lastDonatedOn.trim() : '') : '',
              ailments: donorData !== '' ? donorData.ailments : [],
              height: donorData !== '' && donorData.height ? donorData.height : '',
              weight: donorData !== ''  && donorData.weight ? donorData.weight : '',
              alternatePhone: donorData !== '' && donorData.alternatePhone ? donorData.alternatePhone : '',
              availableAfter: donorData.availableAfter && donorData !== '' ? donorData.availableAfter.trim() : '',
              officeAddress: donorData !== '' && donorData.officeAddress ? donorData.officeAddress : '',
              officePincode: donorData !== '' && donorData.officePincode ? donorData.officePincode : '',
              officePhone: donorData !== '' && donorData.officePhone ? donorData.officePhone : '',
              occupation: donorData !== '' ? donorData.occupation : '',
              frequency: donorData !== '' ? donorData.frequency : '3',
              dayPreference: donorData !== '' ? donorData.dayPreference : 'Any day',              
              samithi: donorData !== '' ? donorData.samithi : '',
              saiConnectId: donorData !== '' ? donorData.saiConnectId : '',
              language: donorData !== '' ? donorData.language : '',
              notes: donorData !== '' ? donorData.notes : '',
              callNotes: donorData !== '' ? donorData.callNotes : '',
              isActive: donorData !== '' ? donorData.isActive : 'Y',
              userCaptcha: ''              
          }}
      validationSchema={Yup.object().shape({
        fullName: Yup.string()
              .required('full name is required'),
        dateOfBirth: Yup.string()                
              .required('dateOfBirth is required')
              .test('dobval0', 'Date format dd-mm-yyyy',value => {
                return moment(value,'DD-MM-YYYY',true).isValid();
              } )
              .test('dobval1', 'Age must be between 18 and 60',value => {
                return moment().diff(moment(value,'DD-MM-YYYY'),'years',true) >= 18;
              } )
              .test('dobval2', 'Age must be between 18 and 60',value => {
                return moment().diff(moment(value,'DD-MM-YYYY'),'years',true) <= 60;
              } ),
        email: Yup.string()
              .required('email is required')
              .email('email is invalid'),
        address: Yup.string()
          .required('address is required'),
        phone: Yup.string()                
              .required('mobile number is required')
              .matches(/^[1-9]+[0-9]*$/, 'Please provide a valid mobile number with only numbers and without preceding zero')
              .length(10,'Please enter 10 digits without any spaces'),
        height: Yup.number()                
          .test('hpos', 'Please provide valid height in cms', val => { return val !== undefined && val !== null && val !== '' ? val > 0 : true }),
        weight: Yup.number()                
          .test('wpos', 'Please provide valid weight in Kgs', val => { return val !== undefined && val !== null && val !== '' ? val > 0 : true }),          
        pincode: Yup.string()                
          .required('pincode is required')
          .matches(/^[1-9]+[0-9]*$/, 'Please provide a valid pincode with only numbers and without preceding zero')
          .length(6,'Please enter 6 digits without any spaces'),
        officePincode: Yup.string()
          .matches(/^[1-9]+[0-9]*$/, 'Please provide a valid office pincode with only numbers and without preceding zero')
          .length(6,'Please enter 6 digits without any spaces'),          
        lastDonatedOn: Yup.string()                
          .test('ldval0', 'Date format dd-mm-yyyy',value => {
          return (value !== undefined && value !== null && value !== '') ? moment(value,'DD-MM-YYYY',true).isValid() :  true;
        } )
          .test('ldval1', 'future date!!',value => {
          return (value !== undefined && value !== null && value !== '') ? moment().diff(moment(value,'DD-MM-YYYY'),'days',true) >= 0  :  true;
        } ),
        availableAfter: Yup.string()                
          .test('ldval2', 'Date format dd-mm-yyyy',value => {
          return (value !== undefined && value !== null && value !== '') ? moment(value,'DD-MM-YYYY',true).isValid() :  true;
        } ),
        userCaptcha: Yup.string()                
        .test('userCaptcha', 'Invalid captcha',value => {
          if(this.state.accessMode === 'admin')
            return true;
          else  
            return (value && validateCaptcha(value,false));
        }),
      })}
      onSubmit={        
        fields => {
          let id = donorData !== '' ? donorData.id : undefined;
          let fullname = fields.fullName;
          let dateOfBirth = fields.dateOfBirth;
          let gender = fields.gender;
          let email = fields.email;
          let bloodGroup = fields.bloodGroup;
          let phone = fields.phone;
          let lastDonatedOn = fields.lastDonatedOn;
          let ailments = fields.ailments;
          let address = fields.address;
          let pincode = fields.pincode;
          let height = fields.height;
          let weight = fields.weight;
          let alternatePhone = fields.alternatePhone;
          let availableAfter = fields.availableAfter ? fields.availableAfter : '01-01-2021';
          let officeAddress = fields.officeAddress;
          let officePincode = fields.officePincode;
          let officePhone = fields.officePhone;
          let occupation = fields.occupation;
          let frequency = fields.frequency;
          let isActive = fields.isActive;
          let createTimestamp = donorData.createTimestamp;
          let modifiedTimestamp = donorData.modifiedTimestamp;
          let modifiedBy = donorData.modifiedBy;
          let dayPreference = fields.dayPreference;          
          let notes = fields.notes;
          let samithi = fields.samithi;
          let saiConnectId = fields.saiConnectId;
          let language = fields.language;
          let otp = donorData !== '' ? donorData.otp : '';
          let otpExpiresIn = donorData.otpExpiresIn;
          let callNotes = donorData !== '' ? donorData.callNotes : '';
          const data = {
            id,fullname,dateOfBirth,gender,bloodGroup,email,phone,lastDonatedOn,ailments,address,pincode,height,weight,alternatePhone,availableAfter,officeAddress,officePincode,officePhone,occupation,frequency,notes,callNotes,isActive,createTimestamp,modifiedTimestamp,modifiedBy,dayPreference,samithi,saiConnectId,language,otp,otpExpiresIn
          };
        
          const payload = {
            data: data,
            token: this.props.response.login.userToken
          }
          message = 'Processing your request';
          this.handleShow();
          if(this.state.accessMode === 'admin')
            this.props.dispatch(updateDonorAction(payload));
          else if(this.state.accessMode === 'self-service')
            this.props.dispatch(selfserviceDonorAction(payload));  
          else{
            this.props.dispatch(donorFormSubmitAction(data));
          }          
      }      
    }    
      render={({ errors, touched }) => (                    
        <div className="wrapper">
          <HomePageHeader />
          <HomeNav adminName={this.props.response.login.adminName}/>
          <div
            style={{
              backgroundImage: "url(" + require("assets/img/shivaratri-wallpapers-6.png") + ")",
              backgroundSize: "cover",
              backgroundPosition: "top center",
              minHeight: "700px",
            }}
          >            
            <Container>
              <Row>
                <Card className="card-signup" data-background-color="blue">
                  <CardHeader className="text-center">
                      <CardTitle className="title-up" tag="h3">
                       Liquid Love Donor {this.state.accessMode === 'admin' || this.state.accessMode === 'self-service' ? 'Update' : 'Sign Up'} 
                      </CardTitle>                  
                  </CardHeader>
                  <CardBody>
                    <Form>
                      <Modal
                      centered
                      show={this.state.show}
                      onHide={this.handleClose}
                      backdrop="static"
                      keyboard={false}
                      >
                        <Modal.Body>
                          {message}
                        </Modal.Body>
                        <Modal.Footer>
                          <Button disabled={!this.state.modalOKEnabled} className="btn btn-primary mr-2" variant="primary" onClick={this.handleClose}>
                            OK
                          </Button>
                        </Modal.Footer>
                      </Modal>
                      <InputGroup
                        className={
                          "no-border input-sm" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                      >
                          <InputGroupText>
                          full name
                          </InputGroupText>
                        <Field name="fullName" type="text" className={'form-control' + (errors.fullName && touched.fullName ? ' is-invalid' : '')} />
                        <ErrorMessage name="fullName" component="div" className="invalid-feedback" />
                      </InputGroup>
                      <InputGroup
                        className={
                          "no-border input-sm" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                      >
                          <InputGroupText>
                          dob
                          </InputGroupText>
                        <Field name="dateOfBirth" type="text" className={'form-control' + (errors.dateOfBirth && touched.dateOfBirth ? ' is-invalid' : '')} />
                          <ErrorMessage name="dateOfBirth" component="div" className="invalid-feedback" />
                        </InputGroup>
                        <div role="group" aria-labelledby="my-radio-group">
                        <Label check>
                          <Field
                            id="male"
                            name="gender"
                            type="radio"
                            value="male"                            
                          ></Field>
                          male <span className="form-check-sign"></span>
                        </Label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Label check>
                          <Field
                            id="female"
                            name="gender"
                            type="radio"
                            value="female"
                          ></Field>
                          female <span className="form-check-sign"></span>
                        </Label>                        
                      </div>
                      <InputGroup
                        className={
                          "no-border input-sm" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                        >
                          <InputGroupText>
                          blood group
                          </InputGroupText>
                        <Field 
                        className="no-border input-sm  input-group-focus"
                        name="bloodGroup" id="bloodGroup" component="select">
                          <option>O+</option>
                          <option>O-</option>
                          <option>A+</option>
                          <option>A-</option>
                          <option>B+</option>
                          <option>B-</option>
                          <option>AB+</option>
                          <option>AB-</option>
                          <option>A1+</option>
                          <option>A1-</option>
                          <option>A1B+</option>
                          <option>A1B-</option>
                          <option>A2+</option>
                          <option>A2-</option>
                          <option>A2B+</option>
                          <option>A2B-</option>
                          <option>Hh</option>
                        </Field>
                        </InputGroup>
                        <InputGroup
                        className={
                          "no-border input-sm" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                        >
                          <InputGroupText>
                          mobile
                          </InputGroupText>
                          <Field name="phone" type="text" className={'form-control' + (errors.phone && touched.phone ? ' is-invalid' : '')} />
                          <ErrorMessage name="phone" component="div" className="invalid-feedback" />
                        </InputGroup>                                                                      
                        <InputGroup
                        className={
                          "no-border input-sm" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                      >
                            <InputGroupText>
                            email
                            </InputGroupText>
                          <Field name="email" type="text" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} />
                          <ErrorMessage name="email" component="div" className="invalid-feedback" />
                        </InputGroup>                                                
                       <InputGroup
                        className={
                          "no-border input-sm" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                        >
                          <InputGroupText>
                          present<br/>address
                          </InputGroupText>
                          <Field name="address" component="textarea" rows="10" className={'form-control' + (errors.address && touched.address ? ' is-invalid' : '')} />
                          <ErrorMessage name="address" component="div" className="invalid-feedback" />
                        </InputGroup>                                                          
                        <InputGroup
                        className={
                          "no-border input-sm" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                        >
                          <InputGroupText>
                          pincode
                          </InputGroupText>
                          <Field name="pincode" type="text" className={'form-control' + (errors.pincode && touched.pincode ? ' is-invalid' : '')} />
                          <ErrorMessage name="pincode" component="div" className="invalid-feedback" />
                        </InputGroup>                                                                      
                        <InputGroup
                        className={
                          "no-border input-sm" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                      >
                          <InputGroupText>
                          last donated
                          </InputGroupText>
                        <Field name="lastDonatedOn" type="text" className={'form-control' + (errors.lastDonatedOn && touched.lastDonatedOn ? ' is-invalid' : '')} />
                          <ErrorMessage name="lastDonatedOn" component="div" className="invalid-feedback" />
                        </InputGroup>                        
                        <div role="group" aria-labelledby="my-radio-group">
                        (dd-mm-yyyy)<br></br><br></br>
                          ailments (if any)<br></br>
                        <Label check>
                          <Field
                            id="diabetic"
                            name="ailments"
                            type="checkbox"
                            value="diabetic"                            
                          ></Field>
                          &nbsp;diabetic <span className="form-check-sign"></span>
                        </Label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Label check>
                          <Field
                            id="hypertension"
                            name="ailments"
                            type="checkbox"
                            value="hypertension"
                          ></Field>
                          &nbsp;hypertension <span className="form-check-sign"></span>
                        </Label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Label check>
                          <Field
                            id="others"
                            name="ailments"
                            type="checkbox"
                            value="others"
                          ></Field>
                          &nbsp;others <span className="form-check-sign"></span>
                        </Label>
                        <br></br><br></br>
                        <InputGroup
                        className={
                          "no-border input-sm" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                        >
                        <Input>
                          <InputGroupText hidden>
                          height(cms)
                          </InputGroupText>
                        </Input>
                          <Field hidden name="height" type="text" className={'form-control' + (errors.height && touched.height ? ' is-invalid' : '')} />
                          <ErrorMessage name="height" component="div" className="invalid-feedback" />
                        </InputGroup>                                                                      
                        <InputGroup
                        className={
                          "no-border input-sm" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                        >
                          <InputGroupText>
                          weight(kgs)
                          </InputGroupText>
                          <Field name="weight" type="text" className={'form-control' + (errors.weight && touched.weight ? ' is-invalid' : '')} />
                          <ErrorMessage name="weight" component="div" className="invalid-feedback" />
                        </InputGroup>
                        {this.state.accessMode === 'admin' ? '' :
                          <div><LoadCanvasTemplate reloadText="Reload" /></div>
                        }
                        {this.state.accessMode === 'admin' ? '' :
                        <InputGroup
                          className={
                            "no-border input-sm" +
                            (this.state.firstFocus ? " input-group-focus" : "")
                          }
                          >
                            <InputGroupText>
                            Captcha
                            </InputGroupText>
                            <Field name="userCaptcha" type="textarea" className={'form-control' + (errors.userCaptcha && touched.userCaptcha ? ' is-invalid' : '')} />
                            <ErrorMessage name="userCaptcha" component="div" className="invalid-feedback" />
                        </InputGroup>
                        }
                        <form><input onChange={e => {this.buttonRef.current.disabled = !e.target.checked}} name="agreement" type="checkbox" />
                          &nbsp;I consent to blood request email/sms notifications</form>                                                                       
                        Additional details (If any)
                        <button id="toggler" className="btn btn-primary btn-icon btn-round">
                          <i className="now-ui-icons arrows-1_minimal-down"></i>
                        </button>
                        <UncontrolledCollapse toggler="#toggler">
                          <div>
                            <InputGroup
                            className={
                              "no-border input-sm" +
                              (this.state.firstFocus ? " input-group-focus" : "")
                            }
                            >
                              <InputGroupText>
                              alternate phone
                              </InputGroupText>
                              <Field name="alternatePhone" type="text" className={'form-control' + (errors.alternatePhone && touched.alternatePhone ? ' is-invalid' : '')} />
                              <ErrorMessage name="alternatePhone" component="div" className="invalid-feedback" />
                            </InputGroup>
                            <InputGroup hidden
                              className={
                                "no-border input-sm" +
                                (this.state.firstFocus ? " input-group-focus" : "")
                              }
                              >
                              <Input hidden>
                                <InputGroupText hidden>
                                donate once in (months)
                                </InputGroupText>
                              </Input>                        
                              <Field hidden 
                              className="no-border input-sm  input-group-focus"
                              name="frequency" id="frequency" component="select">
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                                <option>6</option>
                                <option>7</option>
                                <option>8</option>
                                <option>9</option>
                                <option>10</option>
                                <option>11</option>
                                <option>12</option>
                              </Field>
                            </InputGroup>
                            <InputGroup
                              className={
                                "no-border input-sm" +
                                (this.state.firstFocus ? " input-group-focus" : "")
                              }
                            >
                                <InputGroupText>
                                available after
                                </InputGroupText>
                              <Field name="availableAfter" type="text" className={'form-control' + (errors.availableAfter && touched.availableAfter ? ' is-invalid' : '')} />
                              <ErrorMessage name="availableAfter" component="div" className="invalid-feedback" />
                            </InputGroup>
                            (dd-mm-yyyy)<br></br><br></br>
                            <InputGroup hidden
                              className={
                                "no-border input-sm" +
                                (this.state.firstFocus ? " input-group-focus" : "")
                              }
                              >
                              <Input hidden>
                                <InputGroupText hidden>
                                office address
                                </InputGroupText>
                              </Input>                        
                                <Field hidden name="officeAddress" component="textarea" rows="10" className={'form-control' + (errors.officeAddress && touched.officeAddress ? ' is-invalid' : '')} />
                                <ErrorMessage name="officeAddress" component="div" className="invalid-feedback" />
                            </InputGroup>
                            <InputGroup hidden
                            className={
                              "no-border input-sm" +
                              (this.state.firstFocus ? " input-group-focus" : "")
                            }
                            >
                            <Input hidden>
                              <InputGroupText hidden>
                              office phone
                              </InputGroupText>
                            </Input>
                              <Field hidden name="officePhone" type="text" className={'form-control' + (errors.officePhone && touched.officePhone ? ' is-invalid' : '')} />
                              <ErrorMessage name="officePhone" component="div" className="invalid-feedback" />
                            </InputGroup>
                            <InputGroup hidden
                            className={
                              "no-border input-sm" +
                              (this.state.firstFocus ? " input-group-focus" : "")
                            }
                            >
                            <Input hidden>
                              <InputGroupText hidden>
                              occupation
                              </InputGroupText>
                            </Input>
                              <Field hidden name="occupation" type="text" className={'form-control' + (errors.occupation && touched.occupation ? ' is-invalid' : '')} />
                              <ErrorMessage name="occupation" component="div" className="invalid-feedback" />
                            </InputGroup>
                            <InputGroup hidden
                            className={
                              "no-border input-sm" +
                              (this.state.firstFocus ? " input-group-focus" : "")
                            }
                            >
                            <Input hidden>
                              <InputGroupText hidden>
                              office pincode
                              </InputGroupText>
                            </Input>
                              <Field hidden name="officePincode" type="text" className={'form-control' + (errors.officePincode && touched.officePincode ? ' is-invalid' : '')} />
                              <ErrorMessage name="officePincode" component="div" className="invalid-feedback" />
                            </InputGroup>
                            <InputGroup
                            className={
                              "no-border input-sm" +
                              (this.state.firstFocus ? " input-group-focus" : "")
                            }
                            >
                              <InputGroupText>
                              communication<br/>language
                              </InputGroupText>
                              <Field name="language" type="text" className={'form-control' + (errors.language && touched.language ? ' is-invalid' : '')} />
                              <ErrorMessage name="language" component="div" className="invalid-feedback" />
                            </InputGroup>
                            <InputGroup hidden
                            className={
                              "no-border input-sm" +
                              (this.state.firstFocus ? " input-group-focus" : "")
                            }
                            >
                            <Input hidden>
                              <InputGroupText hidden>
                              sai connectID
                              </InputGroupText>
                            </Input>
                              <Field hidden name="saiConnectId" type="text" className={'form-control' + (errors.saiConnectId && touched.saiConnectId ? ' is-invalid' : '')} />
                              <ErrorMessage name="saiConnectId" component="div" className="invalid-feedback" />
                            </InputGroup>
                            <InputGroup hidden
                            className={
                              "no-border input-sm" +
                              (this.state.firstFocus ? " input-group-focus" : "")
                            }
                            >
                            <Input hidden>
                              <InputGroupText hidden>
                              samithi
                              </InputGroupText>
                            </Input>
                              <Field hidden name="samithi" type="text" className={'form-control' + (errors.samithi && touched.samithi ? ' is-invalid' : '')} />
                              <ErrorMessage name="samithi" component="div" className="invalid-feedback" />
                            </InputGroup>
                            {this.state.accessMode === 'admin' || this.state.accessMode === 'self-service' ?                            
                            <InputGroup
                            className={
                              "no-border input-sm" +
                              (this.state.firstFocus ? " input-group-focus" : "")
                            }
                            >
                              <InputGroupText>
                              Other info / <br/>Closure notes
                              </InputGroupText>
                              <Field name="notes" type="text" className={'form-control' + (errors.notes && touched.notes ? ' is-invalid' : '')} />
                              <ErrorMessage name="notes" component="div" className="invalid-feedback" />
                            </InputGroup>
                          : ''}                                                                                                                                        
                            {this.state.accessMode === 'admin'  ?
                            <InputGroup
                            className=
                              "no-border input-sm"
                            >
                              <InputGroupText>
                              preferred day 
                              </InputGroupText>
                            <Field 
                            className="no-border input-sm  input-group-focus"
                            name="dayPreference" id="dayPreference" component="select">
                              <option>Any day</option>
                              <option>Only weekdays</option>
                              <option>Only weekends</option>
                            </Field>
                          </InputGroup>                            
                          : ''}                                                                           
                            {this.state.accessMode === 'admin'  ?                            
                            <div role="group" aria-labelledby="my-radio-group">
                            Active? &nbsp;&nbsp;&nbsp;
                              <Label check>
                                <Field
                                  id="Yes"
                                  name="isActive"
                                  type="radio"
                                  value="Y"
                                ></Field>
                                yes <span className="form-check-sign"></span>
                              </Label>
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              <Label check>
                                <Field
                                  id="No"
                                  name="isActive"
                                  type="radio"
                                  value="N"
                                ></Field>
                                no <span className="form-check-sign"></span>
                              </Label>
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              <Label check>
                                <Field
                                  id="Review"
                                  name="isActive"
                                  type="radio"
                                  value="R"
                                ></Field>
                                review <span className="form-check-sign"></span>
                              </Label>                                                      
                            </div>                        
                        : ''}                                                  
                          </div>
                        </UncontrolledCollapse>
                      </div>                        
                      <div className="form-group">
                        <button type="submit" 
                        disabled={this.state.accessMode === 'admin' ? false : true}
                        ref={this.buttonRef} className="btn btn-sm btn-primary mr-2">{this.state.accessMode === 'admin' || this.state.accessMode === 'self-service' ? 'Update' : 'Register'}</button>
                        <button type="reset" className="btn btn-sm btn-secondary">Reset</button>
                        {this.state.accessMode === 'admin'  ? 
                        <Button className="btn btn-sm btn-primary mr-2" onClick={() => this.backToDonors()}>Go to donors</Button>
                        : ''}
                        {this.state.accessMode === 'admin'  ? 
                        <Button className="btn btn-sm btn-primary mr-2" onClick={() => this.backToRequests()}>Go to requests</Button>
                        : ''}
                      </div>                                              
                    </Form>
                    </CardBody>
                </Card>                
              </Row>                            
            </Container>                        
          </div>
          <DefaultFooter />
          </div>
        )}
        />
      )
}};
  
const mapStateToProps = (response) => ({response});

export default connect(mapStateToProps)((props) => {
  const navigate = useNavigate();
  const location = useLocation();
  return <LiquidLoveDonorPage navigate={navigate} location={location} {...props} />
});